import Axios from "@app/api/axios";

const patchOrderInvoiceStatus = (payload) => {
  return Axios.patch(`orders/invoice-status`, payload);
};
export default patchOrderInvoiceStatus;
